import { locale } from "svelte-i18n";
import { get } from "svelte/store";

const DEFAULT_LANG = "en";

export const LANGUAGES = [
    {
        value: "en",
        text: "English",
    },
];

export function getLocalizedField(field) {
    if (!field || typeof field !== "object") return field;
    const [currentLocale] = get(locale).split("-");
    return field[currentLocale] || field[DEFAULT_LANG];
}
